import { Box } from '@mui/material';

export const DoctorWorkBench = () => {
  return <Box sx={{ flex: 1 }}> </Box>;
};
